<template>
  <div>
    <div class="base-mobile-card-container mb-4">
      <div v-for="(row, index) in tableData" :key="index" class="base-mobile-card w-full">
        <!-- Header -->
        <div class="base-mobile-card-header">
          <span class="base-mobile-card-title">{{ row[titleKey] }}</span>
        </div>

        <!-- Body -->
        <div class="base-mobile-card-body" v-if="cardLabels.length > 0">
          <div v-for="col in cardLabels" :key="col.key" class="card-field">
            <span class="card-label">{{ $t(col.label) | capitalize }}:</span>
            <span class="card-value">
              <slot :name="`col-${col.key}`" :row="row">
                {{ row[col.key] }}
              </slot>
            </span>
          </div>
        </div>

        <!-- Footer / Actions -->
        <div v-if="actionButtons && actionButtons.length" class="base-mobile-card-actions">
          <vs-button 
            v-for="(button, btnIndex) in actionButtons" 
            :key="'action-' + btnIndex"
            @click="() => { if (typeof button.onClick === 'function') button.onClick(row) }"
            v-if="(button.hideIf ? button.hideIf(row) : true) && canAccess(button.permissions)" 
            :color="VARIANT_COLORS[button.color] || VARIANT_COLORS.primary"
            type="border">
            {{ $t(button.text) | capitalize }}
          </vs-button>
        </div>
      </div>
    </div>

    <!-- Trigger para carga infinita -->
    <div v-if="tableData.length" v-observe-visibility="onVisibilityChanged" style="visibility:hidden"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { canAccess } from '@/utils/helpers'

const props = defineProps({
  tableColumns: { type: Array, required: true, default: () => [] },
  tableData: { type: Array, required: true },
  actionButtons: { type: Array },
  titleKey: { type: String, required: true }
})

const emit = defineEmits(['loadMore'])

const cardLabels = computed(() =>
  props.tableColumns.filter(col => col.key !== props.titleKey)
)

function onVisibilityChanged(isVisible) {
  if (isVisible) {
    emit('loadMore')
  }
}

const VARIANT_COLORS = {
  primary: '#195BFF',
  info: '#7367F0',
  success: '#28C76F',
  danger: '#BC1300',
  warning: '#ff9f43',
  black: '#000000',
}

</script>

<style>
.base-mobile-card-container {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.base-mobile-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

/* Header */
.base-mobile-card-header {
  background: #BC1300;
  padding: 14px;
  display: flex;
  align-items: center;
}

.base-mobile-card-title {
  font-weight: 600;
  font-size: 1.1rem;
  color: #fff;
  letter-spacing: 0.5px;
}

/* Body */
.base-mobile-card-body {
  padding: 16px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
}

.card-field {
  margin-bottom: 6px;
}

.card-label {
  font-weight: bold;
  color: #ba1300;
  margin-right: 4px;
}

.card-value {
  color: #333;
}

/* Footer / Actions */
.base-mobile-card-actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  background: #fff;
  gap: 10px;
  border-top: 1px solid #f0f0f0;
}

/* Trigger aislado */
.module-card-trigger {
  height: 1px;
  background: none;
}
</style>